import { Button, Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FreelancerOnboardingStatus } from "../../../../../models/enums/FreelancerOnboardingStatus";
import { FreelancerProfile } from "../../../../../models/FreelancerProfile";

interface NavigationButtonsProps {
	readonly onReturnToPreviousStep: () => void;
	readonly isFormValid: boolean;
	readonly isSubmitting: boolean;
	readonly freelancerProfile: FreelancerProfile;
}

export default function NavigationButtons({
	onReturnToPreviousStep,
	isFormValid,
	isSubmitting,
	freelancerProfile
}: NavigationButtonsProps) {
	const { t } = useTranslation();

	return (
		<Grid2 container spacing={2} columns={12} direction={"column"}>
			<Grid2 size={{ sm: 12, md: 4 }}>
				<Button
					type="submit"
					color="secondary"
					variant="contained"
					fullWidth
					disabled={!isFormValid || isSubmitting}
				>
					{freelancerProfile?.onboarding.currentStatus !==
					FreelancerOnboardingStatus.Accepted
						? t("freelancerOnboardingMyAvailability.professionalInfo")
						: t("common.save")}
				</Button>
			</Grid2>
			{freelancerProfile?.onboarding.currentStatus !==
				FreelancerOnboardingStatus.Accepted && (
				<Grid2 size={{ sm: 12, md: 4 }}>
					<Button
						color="secondary"
						variant="outlined"
						onClick={onReturnToPreviousStep}
						fullWidth
					>
						{t("freelancerOnboardingMyAvailability.return")}
					</Button>
				</Grid2>
			)}
		</Grid2>
	);
}
